import { registerLocaleData } from '@angular/common';
import localeBg from '@angular/common/locales/bg';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeEt from '@angular/common/locales/et';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeHr from '@angular/common/locales/hr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeLt from '@angular/common/locales/lt';
import localeLv from '@angular/common/locales/lv';
import localeNl from '@angular/common/locales/nl';
import localeNo from '@angular/common/locales/no';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeSk from '@angular/common/locales/sk';
import localeSl from '@angular/common/locales/sl';
import localeSv from '@angular/common/locales/sv';
import localeTh from '@angular/common/locales/th';
import localeUk from '@angular/common/locales/uk';
import localeZh from '@angular/common/locales/zh';

/**
 * Angular locale data for every language the UI can be switched to.
 *
 * `LOCALE_ID` is set from the resolved language (see `app.config.ts`), and
 * `DatePipe` & friends throw when the data for that locale has not been
 * registered. Since the resolved language can be any of the 28 codes the
 * library ships translations for, all of them are registered up front —
 * roughly 11 KB gzipped in total.
 *
 * Must be imported before the application bootstraps.
 */
const LOCALE_DATA = [
  localeBg, localeCs, localeDa, localeDe, localeEl, localeEn, localeEs,
  localeEt, localeFi, localeFr, localeHr, localeHu, localeIt, localeJa,
  localeLt, localeLv, localeNl, localeNo, localePl, localePt, localeRo,
  localeRu, localeSk, localeSl, localeSv, localeTh, localeUk, localeZh,
];

export function registerSupportedLocales(): void {
  LOCALE_DATA.forEach((data) => registerLocaleData(data));
}
